<script>
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { studyProperties, isFeatureEnabled, fetchStudyProperties } from '$stores/configStore';
  import { 
    faMicrochip,
    faDroplet,
    faBook,
    faBell
  } from '@fortawesome/pro-light-svg-icons';

  // Feature flag variables
  let isSMBGEnabled = true;
  let isDiaryEnabled = true;
  let isMessagingEnabled = true;

  // Reactive variables for feature flags
  $: {
    isSMBGEnabled = true; // isFeatureEnabled('smbg');
    isDiaryEnabled = true; // isFeatureEnabled('diary');
    isMessagingEnabled = true; // isFeatureEnabled('messaging');
  }

  export let cgmCount = 0;
  export let smbgCount = 0;
  export let formCount = 0;
  export let messageCount = 0;
</script>

<div class="grid grid-cols-4 gap-4 px-1 mt-3">
  <!-- CGM Readings Card -->
  <div class="bg-stone-200/50 dark:bg-gray-800/90 rounded-lg shadow p-4 border-l-2 border-[#4BC0C0]">
    <div class="flex items-center gap-2 mb-2">
      <FontAwesomeIcon icon={faDroplet} class="text-xl text-[#4BC0C0]" />
      <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300">CGM Readings</h3>
    </div>
    <p class="text-lg font-bold text-gray-900 dark:text-white">{cgmCount}</p>
    <p class="text-xs text-gray-500 dark:text-gray-400">Continuous glucose readings</p>
  </div>

  {#if isSMBGEnabled}
  <!-- SMBG Readings Card -->
  <div class="bg-stone-200/50 dark:bg-gray-800/90 rounded-lg shadow p-4 border-l-2 border-[#FF6384]">
    <div class="flex items-center gap-2 mb-2">
      <FontAwesomeIcon icon={faDroplet} class="text-xl text-[#FF6384]" />
      <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300">SMBG Readings</h3>
    </div>
    <p class="text-lg font-bold text-gray-900 dark:text-white">{smbgCount}</p>
    <p class="text-xs text-gray-500 dark:text-gray-400">Self-monitoring readings</p>
  </div>
  {/if}
  {#if isDiaryEnabled}
  <!-- Diary Entries Card -->
  <div class="bg-stone-200/50 dark:bg-gray-800/90 rounded-lg shadow p-4 border-l-2 border-[#0A96C8]">
    <div class="flex items-center gap-2 mb-2">
      <FontAwesomeIcon icon={faBook} class="text-xl text-[#0A96C8]" />
      <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300">Diary Entries</h3>
    </div>
    <p class="text-lg font-bold text-gray-900 dark:text-white">{formCount}</p>
    <p class="text-xs text-gray-500 dark:text-gray-400">Diary submissions</p>
  </div>
  {/if}
  {#if isMessagingEnabled}
  <!-- Alerts/Messages Card -->
  <div class="bg-stone-200/50 dark:bg-gray-800/90 rounded-lg shadow p-4 border-l-2 border-[#FFCE56]">
    <div class="flex items-center gap-2 mb-2">
      <FontAwesomeIcon icon={faBell} class="text-xl text-[#FFCE56]" />
      <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300">Alerts/Messages</h3>
    </div>
    <p class="text-lg font-bold text-gray-900 dark:text-white">{messageCount}</p>
    <p class="text-xs text-gray-500 dark:text-gray-400">System notifications</p>
  </div>
  {/if}
</div> 